import * as React from 'react'

import PreNavigationBanner from './preNavigationBanner'

import { safeParseHtml } from '../../libs/safeHtml'

interface PreNavigationBannerAppButton {
  text: string,
  href: string,
  target?: string,
  className?: string,
}

// ReactOnRails entry point that adapts server-rendered banners (with Ruby-composed
// HTML content and cookie-based dismissal) onto the shared PreNavigationBanner.
interface PreNavigationBannerAppProps {
  variant?: string,
  bodyHTML: string,
  button?: PreNavigationBannerAppButton,
  dismissable?: boolean,
  dismissAriaLabel?: string,
  cookieName?: string,
  cookieMaxAgeSeconds?: number,
}

function cookieIsSet(name: string) {
  if (typeof document === 'undefined') { return false }
  return document.cookie.includes(`${name}=1`)
}

const PreNavigationBannerApp = ({ variant, bodyHTML, button, dismissable, dismissAriaLabel, cookieName, cookieMaxAgeSeconds, }: PreNavigationBannerAppProps) => {
  const [isVisible, setIsVisible] = React.useState(() => !(cookieName && cookieIsSet(cookieName)))

  function handleDismiss() {
    if (cookieName) {
      const expiry = cookieMaxAgeSeconds ? `; max-age=${cookieMaxAgeSeconds}` : ''
      document.cookie = `${cookieName}=1; path=/${expiry}`
    }
    setIsVisible(false)
  }

  if (!isVisible) { return null }

  const text = <span>{safeParseHtml(bodyHTML)}</span>

  return (
    <PreNavigationBanner
      button={button}
      dismissAriaLabel={dismissAriaLabel}
      onDismiss={dismissable ? handleDismiss : undefined}
      text={text}
      variant={variant}
    />
  )
}

export default PreNavigationBannerApp
